import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import {
  HeadContent,
  MediaQueryProvider,
  SuspenseFallback,
  ToastsProvider,
} from '@fourthwall/components'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { FallbackGlobalStyles } from './components/assets/FallbackGlobalStyles/FallbackGlobalStyles'
import { WebviewEventsBusProvider } from './contexts/WebviewEventsBusContext'
import { App } from './modules/App'
import { queryClient } from './queryClient'
import './styles.css'

export const Root = () => (
  <>
    <FallbackGlobalStyles />
    <HeadContent titleTemplate="%s &ndash; Dashboard" defaultTitle="Dashboard" />
    <Suspense fallback={<SuspenseFallback />}>
      <QueryClientProvider client={queryClient}>
        <MediaQueryProvider>
          <ToastsProvider>
            <BrowserRouter>
              <QueryParamProvider adapter={ReactRouter6Adapter}>
                <WebviewEventsBusProvider>
                  <App />
                </WebviewEventsBusProvider>
              </QueryParamProvider>
            </BrowserRouter>
          </ToastsProvider>
        </MediaQueryProvider>
        <ReactQueryDevtools position="bottom-right" />
      </QueryClientProvider>
    </Suspense>
  </>
)
